import { shallow } from 'zustand/shallow';
import { useGamesStore } from '../../store';

export const useProvider = (providerId: string) => {
  return useGamesStore(
    (store) => store.providers.data[providerId] || {},
    shallow
  );
};
